
<template>
  <div>
      <div v-show="showVue" style="width:1300px;margin:0 auto;margin-top:100px;">       
     
         <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888;">   
             <p class="mt-2 mb-2 font">
                <img src="../../static/images/kucun.png" style="width:1.5rem;height:1.5rem;" class="mb-lg-1" alt=""/>
                <span class="p-1" style="text-shadow:#000 1px 0 0;background-color:#3190e8;color:#fff;box-shadow: 6px 4px 9px #888888;font-family: Helvetica Neue,Tahoma,Arial;border-radius:3px;">
                   代办事项列表
                </span>
                <span class="float-right span_close" style="display:block;width:20px;line-height:20px;text-align:center;font-size:25px;margin-right:6px;" @click="$router.go(-1)">
                           &times;
                </span>
              </p>
              
                  <div v-if="showPage" class="text-center">
                      <ul v-for="(item,index) in tableData" :key="index">
                          <li>
                              <span>{{index+1}}</span>
                              <span>
                                {{item}}
                              </span>
                          </li>
                      </ul>
                  </div>


                  <div v-else>

                       <img src="../../static/images/wushuju.jpg" style="width:300px;height:300px;display:block;margin:0 auto;" alt="">

                  </div>



                <p class="text-center">
                    <img src="../../static/images/tuding.png" style="width:1.5rem;height:1.5rem;" alt=""/>
                </p>
       </div> 
      </div>

    <!-- 详情内容 -->

                <div>
                  <transition name='fade'>
                           <loading v-show="isLoading">
                                                
                           </loading>
                  </transition>
                </div>
     </div>
</template>
<script>
import vPagination from "../components/Pagination.vue"
import Loading from '../components/Loading.vue'
import { async } from 'q';
export default {
      name: 'SaleQuery',
    data () {
      return {
        searchForm: {
          supplierNum:"",
        },//搜索内容
        isLoading: false,
        tableData: [],
        Record:'',//总记录数
        Pcount:'',//总页数
        PageNo:1, //当前页码
        showPage:true,
        details:[],
        totalLimitMoney:'',

           total:1,     // 记录总条数
            display: 20,   // 每页显示条数
            current: 1,   // 当前的页数
            showVue:false,

      }
    },
    components:{
        vPagination,
        Loading
    },
    computed:{
         
},
filters: {
  //过滤器时间转换
  //时间转换
      formatUTC:function(utc_datetime) {
          return utc_datetime.replace(/T/ig,"  ").substring(0,20)
        } ,
     
        state:function(state){
            if(state==2)
            {
              return "限制结算50万"
            }
            else{
               return ""
            }
        },
        status:function(status){
          if(status==-1){
            return "删除"
          }
          else
          {
            return ""
          }
        }
},

methods: {

  

      searchEnterFun(e){
         var keyCode = window.event ? e.keyCode : e.which;
         if(keyCode == 13){
           this.Search();
         }
      },
      
        
    
  
      getClerkStoreGoodsQuery: async function (PageIndex) {
          // this.isLoading=true;
        const { data: res } = await this.$http.post('Dls/getFun', {
          action: 'ClerkToDoList',
          obj: JSON.stringify({
          
          }) 
        })
        // console.log(res)
           if(res.isok){
                const obj=res.data
                this.tableData = obj.msgList
                this.showVue=true;
                if(this.tableData.length>0)
                {
                    this.showPage=true;
                }
                else{
                    this.showPage =false;
                }
             
           }
         
      },
  
    },
     mounted(){
    },
     created () {

        this.getClerkStoreGoodsQuery();
        
    }
}
</script>
<style scoped>
   .table-hover>tbody>tr:hover {
    background-color:#dee2e6!important;
}
.font{
  font-size:15px;
}
.font_yz{
  font-size:1px;
  color:red;
}
.button_zi{
      text-shadow:#000 1px 0 0;
      border-radius: 5px;
      border:none;
      color:azure;
  }
  .heit{
    height:1.5rem;
  }
  .span_close:hover{
       color:#3190e8;
 }
 
.autocut{
     overflow:hidden;
      white-space:nowrap;
      text-overflow:ellipsis;
      -o-text-overflow:ellipsis;
     -khtml-text-overflow: ellipsis;
     -moz-text-overflow: ellipsis;
    -webkit-text-overflow: ellipsis;
}
.jz_middle{
   vertical-align:middle;
 }
</style>


// WEBPACK FOOTER //
// src/pages/Schedule.vue